import {
  BriefcaseBusiness,
  CalendarCheck,
  CheckCircle2,
  ClipboardList,
  Construction,
  FileSearch,
  HeartPulse,
  MonitorCog,
  Network,
  NotebookTabs,
  SearchCheck,
  ShieldCheck,
  Truck,
  UsersRound,
} from "lucide-react";

export const images = {
  hero: "https://static.prod-images.emergentagent.com/jobs/685ae1e6-4183-4c31-8b18-fbf69258879b/images/9dedc9f8770e08c47b82c1cfd8658d182ebbb3386f35772c2590c22610356b18.png",
  services: "https://static.prod-images.emergentagent.com/jobs/685ae1e6-4183-4c31-8b18-fbf69258879b/images/7f594e12326abaf64e47309637fa0fffea460e38ee793ebf1c211769ca980ecc.png",
  boardroom: "https://static.prod-images.emergentagent.com/jobs/685ae1e6-4183-4c31-8b18-fbf69258879b/images/9d1469b86fe4a1d7eb9c6a5cee8dbadf798b892e19bc4994dda949de5bacb9a0.png",
  team: "https://images.pexels.com/photos/5324900/pexels-photo-5324900.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const navItems = [
  { label: "Home", path: "/" },
  { label: "Find Jobs", path: "/jobs" },
  { label: "Post a Job Free", path: "/post-job", isFree: true },
  { label: "Resume Checker", path: "/resume-checker" },
  { label: "Resume Tailor", path: "/resume-tailor", isNew: true },
  { label: "Services", path: "/services" },
  { label: "Contact", path: "/contact" },
];

export const serviceCards = [
  {
    icon: SearchCheck,
    title: "Job Posting Support",
    text: "Clear, professional job postings that explain the role, requirements, company expectations, and next steps for applicants.",
  },
  {
    icon: UsersRound,
    title: "Candidate Sourcing",
    text: "Focused candidate sourcing for companies that need help finding people who match the role, location, and hiring needs.",
  },
];

export const processSteps = [
  { icon: FileSearch, title: "Submit", text: "Companies send a company profile, job details, Calgary location, pay range, and application method." },
  { icon: ShieldCheck, title: "Review", text: "TalentBridge reviews each listing before it is published to the public jobs page." },
  { icon: BriefcaseBusiness, title: "Publish", text: "Approved listings become searchable by category and Calgary-area location." },
  { icon: Network, title: "Apply", text: "Job seekers apply by email, external link, or employer instructions." },
];

export const stats = [
  { value: "FREE", label: "Calgary job portal" },
  { value: "APPROVED", label: "reviewed listings" },
  { value: "YYC", label: "Calgary focused" },
];

export const applicationMethods = ["Email", "External link", "Instructions"];

export const jobServiceTypes = ["Free job", "TalentBridge hiring support"];

export const differentiators = [
  { icon: BriefcaseBusiness, text: "Free Calgary job listings for companies ready to hire." },
  { icon: CheckCircle2, text: "Admin-approved roles before they appear publicly." },
  { icon: CalendarCheck, text: "Simple candidate apply paths chosen by each employer." },
];

export const timeSlots = ["09:00", "10:30", "12:00", "14:00", "15:30", "17:00"];

export const serviceOptions = [
  "Job posting support",
  "Candidate sourcing consultation",
  "Employer hiring consultation",
];

export const jobCategories = [
  "IT Professionals",
  "Administrative Staff",
  "Healthcare Workers",
  "Construction Workers",
  "Truck Drivers",
  "Project & Program Management",
  "General Labour",
  "Other",
  "On-Demand Gigs",
];

export const jobTypes = ["Full-time", "Part-time", "Contract", "Temporary", "Seasonal", "Remote", "Hybrid", "On-Demand"];

export const companyContact = {
  email: "talentbridgeconsulting0@gmail.com",
  location: "Calgary, Alberta",
};

export const talentCategories = [
  {
    icon: NotebookTabs,
    title: "Project & Program Management",
    roles: [
      "Project Managers",
      "Program Managers",
      "Project Coordinators",
      "Project Administrators",
      "PMO Analysts",
      "Scrum Masters",
      "Implementation Managers",
      "Operations Project Leads",
    ],
  },
  {
    icon: MonitorCog,
    title: "IT Professionals",
    roles: ["Help Desk Technicians", "System Administrators", "Software Developers", "Business Analysts", "Cybersecurity Specialists"],
  },
  {
    icon: ClipboardList,
    title: "Administrative Staff",
    roles: ["Administrative Assistants", "Receptionists", "Data Entry Clerks", "Office Managers", "Customer Service Representatives"],
  },
  {
    icon: HeartPulse,
    title: "Healthcare Workers",
    roles: ["Health Care Aides", "Licensed Practical Nurses", "Registered Nurses", "Medical Office Assistants", "Support Staff"],
  },
  {
    icon: Construction,
    title: "Construction Workers",
    roles: ["General Labourers", "Carpenters", "Electricians", "Plumbers", "Equipment Operators", "Site Supervisors"],
  },
  {
    icon: Truck,
    title: "Truck Drivers",
    roles: ["Class 1 Drivers", "Delivery Drivers", "Long-Haul Drivers", "Fleet Operators", "Warehouse Personnel"],
  },
  {
    icon: BriefcaseBusiness,
    title: "On-Demand Gigs",
    roles: ["Event Staff", "Short-Term Admin Support", "Warehouse Helpers", "Delivery Helpers", "General Helpers", "Weekend Crew"],
  },
];